export const weekDays = [
  { label: 'Sunday', value: 0 },
  { label: 'Monday', value: 1 },
  { label: 'Tuesday', value: 2 },
  { label: 'Wednesday', value: 3 },
  { label: 'Thursday', value: 4 },
  { label: 'Friday', value: 5 },
  { label: 'Saturday', value: 6 },
];

export enum Devices {
  WhiteBoard = 'White board',
  BigScreen = 'Big screen',
  WaterCooler = 'Water cooler',
  PlayStation = 'PlayStation',
  AirConditioner = 'Air conditioner',
  SoundSystem = 'Sound system',
  TennisTable = 'Tennis table',
  Camera = 'Camera',
}
